import { render, staticRenderFns } from "./EliteligaUpcomingAndHighlightsWidget.vue?vue&type=template&id=6fc4ba18&"
import script from "./EliteligaUpcomingAndHighlightsWidget.vue?vue&type=script&lang=ts&"
export * from "./EliteligaUpcomingAndHighlightsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./EliteligaUpcomingAndHighlightsWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports